import { AGGREGATE_NAMES, PARTNER_RESOLVERS } from 'cpool-constants';
import { schemaPartnerResolver_GetMyPartnerContacts } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

// Scoped server-side to the caller's own pid — empty for users without one.
export const usePartnerContacts = () => {
    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.PARTNER,
        resolverName: PARTNER_RESOLVERS.getMyPartnerContacts,
        schema: schemaPartnerResolver_GetMyPartnerContacts,
        searchParams: {},
    });
};
